export default "__VITE_ASSET__9c0d4970__"